@let content = this.content$ | async;
<cam-loader [isLoading]="this.requestState.isLoading()">
  <cam-error [message]="this.requestState.getErrorMessage()" [code]="this.requestState.getErrorStatus()">
    <cam-empty [isEmpty]="!content">
      @if (content) {
        <cam-title>
          {{ content.Title }}
        </cam-title>

        <cam-rich-text [richText]="content.Description"></cam-rich-text>
      }
    </cam-empty>
  </cam-error>
</cam-loader>
